import { useProjectParams } from '@hooks/useProjectParams';
import type { BimWorkOrderVersionListItem, WorkOrderVersionListItem } from 'gql/graphql';
import type { IWorkOrderVersionListItem } from 'pages/Project/Common/utils';
import { getWorkOrderVersionListItems } from 'pages/Project/Common/utils';
import { Select, SelectItem, cnMixSpace } from 'uikit';

import cn from 'classnames';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import './SelectVersionsWorkOrder.css';

export const SelectVersionsWorkOrder = ({
    data,
    activeItemVersion,
}: {
    data: WorkOrderVersionListItem[] | BimWorkOrderVersionListItem[];
    activeItemVersion?: IWorkOrderVersionListItem;
}) => {
    const navigate = useNavigate();
    const { id: projectId, orderId, methodology } = useProjectParams();

    const modifiedData = useMemo(() => getWorkOrderVersionListItems(data), [data]);

    const defaultPlaceholder = useMemo(() => modifiedData?.[0]?.labelWithoutChangeNumber, [modifiedData]);

    const handleChangeSelect = useCallback(
        ({ value }) => {
            navigate(`/projects/${methodology}/${projectId}/order/${orderId}/version/${value.id}`);
        },
        [methodology, navigate, orderId, projectId],
    );

    if (!data) {
        return null;
    }

    return (
        <Select
            placeholder={defaultPlaceholder}
            style={{ maxWidth: '192px' }}
            className={cn('SelectVersionsWorkOrder', cnMixSpace({ mR: 'xs' }))}
            items={modifiedData}
            value={activeItemVersion}
            onChange={handleChangeSelect}
            size="s"
            disabled={!modifiedData.length}
            renderItem={({ item, active, hovered, onClick, onMouseEnter }) => (
                <SelectItem
                    label={item.labelWithoutChangeNumber}
                    active={active}
                    hovered={hovered}
                    onMouseEnter={onMouseEnter}
                    onClick={onClick}
                    multiple={false}
                    size="s"
                    indent="normal"
                    disabled={false}
                />
            )}
        />
    );
};

SelectVersionsWorkOrder.displayName = 'SelectVersionsWorkOrder';
